module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "callerIdCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createCallerId))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeCallerIdServers : _vm.allCallerIdServers,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'callerIdEdit',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 2223549481)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c845c760","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/callerID/CallerIdServers.vue
// module id = 435
// module chunks = 35